<template>
  <v-row dense>
    <v-col cols="12">
      <v-card class="card-border">
        <v-card-text>
          <v-form ref="formFilter">
            <v-row dense>
              <v-col cols="12" sm="12" md="3">
                <SelectEmpresa
                  @onChanged="empresa = $event"
                  :multiple="false"
                />
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <SelectCampanha
                  :empresas="empresa"
                  @onChanged="campanha = $event"
                />
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <SelectColaborador
                  :multiple="true"
                  :empresas="empresa"
                  @onChanged="colaboradores = $event"
                />
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <SelectImageLayout
                  :campanha="campanha"
                  multiple
                  @onChanged="layouts = $event"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12">
      <v-card class="card-border">
        <v-card-text>
          <v-row justify="center">
            <canvas
              ref="canvas"
              id="canvas"
              :width="canvasSettings.width"
              :height="canvasSettings.height"
              class="elevation-5"
            ></canvas>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" align="center">
      <v-btn
        color="orange darken-2"
        outlined
        rounded
        small
        @click="setColaboradores(true)"
      >
        <v-icon left>mdi-image</v-icon>Teste </v-btn
      >&nbsp;
      <v-btn
        color="blue darken-2"
        outlined
        rounded
        small
        @click="setColaboradores()"
      >
        <v-icon left>mdi-image</v-icon>Salvar
      </v-btn>
    </v-col>
    <v-col cols="12">
      <TabelaErrosMateriais v-show="erros.length > 0" :erros="erros" />
    </v-col>
  </v-row>
</template>

<script>
import { Arquivos } from "@/services/materiais";
import Usuarios from "@/services/usuarios";

export default {
  name: "ImageLayout",

  components: {
    SelectEmpresa: () => import("@/components/select/SelectEmpresa"),
    SelectColaborador: () => import("@/components/select/SelectColaborador"),
    SelectCampanha: () => import("@/components/select/SelectCampanha"),
    SelectImageLayout: () => import("@/components/select/SelectImageLayout"),
    TabelaErrosMateriais: () => import("../components/TabelaErrosMateriais")
  },

  data() {
    return {
      empresa: "",
      colaboradores: [],
      campanha: "",
      layouts: [],

      canvas: null,
      context: null,
      canvasSettings: {
        width: 453 /*425.19*/,
        height: 642 /*595.27*/
      },

      canvasImage: null,
      disableButtons: false,

      erros: []
    };
  },

  methods: {
    setCanvasImage(layout) {
      if (!layout) {
        let context = this.$refs.canvas.getContext("2d");
        context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        return;
      }
      this.loadingCanvas();

      let image = new Image();
      image.crossOrigin = "Anonymous";

      image.onload = () => {
        this.updateCanvas(layout);
      };

      image.src = layout.url;
      this.canvasImage = image;
    },

    loadingCanvas() {
      let context = this.$refs.canvas.getContext("2d");
      context.clearRect(0, 0, this.canvas.width, this.canvas.height);
      context.font = "normal normal 18px arial";
      context.fillText(
        "Carregando....",
        this.canvas.width / 2.5,
        this.canvas.height / 2
      );
    },

    updateCanvas(layout) {
      if (this.canvasImage) {
        this.context.drawImage(
          this.canvasImage,
          0,
          0,
          this.canvasSettings.width,
          this.canvasSettings.height
        );

        this.context.fillStyle = layout.font.color;

        for (let objeto of layout.objetos) {
          let font = `${layout.font.bold} ${layout.font.italic} ${objeto.size}px ${layout.font.value}`;
          this.context.font = font;
          this.context.fillText(objeto.text.toUpperCase(), objeto.x, objeto.y);
        }
      }
    },

    updateCanvasColaborador(colaborador, layout) {
      if (this.canvasImage && colaborador) {
        let hasData = true;

        this.context.drawImage(
          this.canvasImage,
          0,
          0,
          this.canvasSettings.width,
          this.canvasSettings.height
        );

        this.context.fillStyle = layout.font.color;
        for (let objeto of layout.objetos) {
          if (!colaborador[objeto.key]) {
            hasData = false;
            break;
          }
          let font = `${layout.font.bold} ${layout.font.italic} ${objeto.size}px ${layout.font.value}`;
          this.context.font = font;
          this.context.fillText(
            colaborador[objeto.key].toUpperCase(),
            objeto.x,
            objeto.y
          );
        }

        return hasData ? this.canvas.toDataURL() : null;
      }

      return null;
    },

    async setColaboradores(test = false) {
      this.erros = [];
      if (!this.$refs.formFilter.validate()) {
        this.$toast.warning("Selecione todos os parametros.");
        return;
      }

      for (let colaborador of this.colaboradores) {
        let usuarioData = await new Usuarios().getUsuarioByCpf(colaborador.cpf);
        if (!usuarioData) {
          this.$toast.error(
            `<p style="text-align: left">${colaborador.nome} não possui usuário cadastrado.<br><br></p>`
          );
          this.erros.push({
            nome: colaborador.nome,
            erro: "Não possui usuário cadastrado"
          });
          continue;
        }
        if (!usuarioData.apelido || !usuarioData.telefone) {
          this.$toast.error(
            `<p style="text-align: left">${colaborador.nome} está com os dados do usuário incompleto.<br><br></p>`
          );
          this.erros.push({
            nome: colaborador.nome,
            erro: "Está com os dados do usuário incompleto"
          });
          continue;
        }

        for (const layout of this.layouts) {
          this.$loading.setLoading(true);

          let image = new Image();
          image.crossOrigin = "Anonymous";

          image.onload = async () => {
            let imageBase64String = this.updateCanvasColaborador(
              usuarioData,
              layout
            );
            if (!test) {
              try {
                await this.save(colaborador.cpf, imageBase64String, layout);
                this.$toast.success(`${colaborador.nome} salvo com sucesso.`);
              } catch (error) {
                console.error(error);
                this.$toast.error(error);
              } finally {
                this.$loading.setLoading(false);
              }
            } else {
              await this.wait(1000);
            }
          };

          image.src = layout.url;
          this.canvasImage = image;
          await this.wait(2000);
        }
      }

      this.$loading.setLoading(false);
      this.$swal.success("Salvo com sucesso");
    },

    async save(cpf, imageBase64String, layout) {
      try {
        await new Arquivos().createLayoutImage(
          this.empresa,
          cpf,
          this.campanha,
          layout.descricao,
          layout.id,
          imageBase64String
        );
      } catch (error) {
        console.error(error);
        this.$toast.error(error);
      }
    },

    wait(time = 1000) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          return resolve();
        }, time);
      });
    }
  },

  watch: {
    layouts: {
      handler() {
        this.setCanvasImage(this.layouts[this.layouts.length - 1]);
      },
      deep: true
    }
  },

  mounted() {
    this.canvas = this.$refs.canvas;
    this.context = this.canvas.getContext("2d");
  }
};
</script>
